import { useEffect, useRef } from 'react'

export default function Search() {
  const circlesRef = useRef()

  useEffect(() => {
    if (circlesRef.current) {
      circlesRef.current.beginElement()
    }
  })
  return (
    <>
      <g clipPath="url(#clip0_2164_74814)" data-test="component-search">
        <g clipPath="url(#clip1_2164_74814)">
          <path
            opacity="0.2"
            d="M115 481.374C133.4 481.374 133.4 489.66 151.8 489.66C170.25 489.66 170.25 482.212 188.7 482.212C207.1 482.212 207.1 466.211 225.5 466.211C243.9 466.211 243.9 452.455 262.3 452.455C280.7 452.455 280.7 404.916 299.099 404.916C317.55 404.916 317.55 442.215 336 442.215V526C317.55 526 317.55 526 299.099 526C280.7 526 280.7 526 262.3 526C243.9 526 243.9 526 225.5 526C207.1 526 207.1 526 188.7 526C170.25 526 170.25 526 151.8 526C133.4 526 133.4 526 115 526V481.374Z"
            fill="#055A82"
          />
          <path
            className='line-tut'
            d="M115 481.374C133.4 481.374 133.4 489.66 151.8 489.66C170.25 489.66 170.25 482.212 188.7 482.212C207.1 482.212 207.1 466.211 225.5 466.211C243.9 466.211 243.9 452.455 262.3 452.455C280.7 452.455 280.7 404.916 299.099 404.916C317.55 404.916 317.55 442.215 336 442.215"
            stroke="url(#paint0_linear_2164_74814)"
            strokeWidth="2"
          >
          </path>
          <path
            opacity="0.2"
            className='line-tut'
            d="M115 466.232C133.4 466.232 133.4 472.052 151.8 472.052C170.25 472.052 170.25 461.522 188.7 461.522C207.1 461.522 207.1 441.574 225.5 441.574C243.9 441.574 243.9 426.009 262.3 426.009C280.7 426.009 280.7 372 299.099 372C317.55 372 317.55 413.345 336 413.345V442.47C317.55 442.47 317.55 405.451 299.099 405.451C280.7 405.451 280.7 452.633 262.3 452.633C243.9 452.633 243.9 466.285 225.5 466.285C207.1 466.285 207.1 482.166 188.7 482.166C170.25 482.166 170.25 489.557 151.8 489.557C133.4 489.557 133.4 481.334 115 481.334V466.232Z"
            fill="#68C5EA"
          />
          <path
            className='line-tut'
            d="M115 466.232C133.4 466.232 133.4 472.052 151.8 472.052C170.25 472.052 170.25 461.522 188.7 461.522C207.1 461.522 207.1 441.574 225.5 441.574C243.9 441.574 243.9 426.009 262.3 426.009C280.7 426.009 280.7 372 299.099 372C317.55 372 317.55 413.345 336 413.345"
            stroke="url(#paint1_linear_2164_74814)"
            strokeWidth="2"
          />
        </g>
        <g filter="url(#filter7_d_2164_74814)">
          <rect
            x="165"
            y="144"
            width="120"
            height="44"
            rx="22"
            fill="#F9FAFE"
          />
          <path
            d="M182.312 164.521C182.312 161.092 185.092 158.312 188.522 158.312C191.951 158.312 194.731 161.092 194.731 164.521C194.731 165.97 194.235 167.302 193.404 168.359L197.471 172.426C197.54 172.495 197.594 172.576 197.632 172.666C197.669 172.755 197.688 172.852 197.688 172.949C197.688 173.046 197.669 173.142 197.632 173.232C197.594 173.321 197.54 173.403 197.471 173.471C197.403 173.54 197.321 173.594 197.231 173.632C197.142 173.669 197.046 173.688 196.949 173.688C196.851 173.688 196.755 173.669 196.666 173.632C196.576 173.594 196.494 173.54 196.426 173.471L192.358 169.403C191.265 170.265 189.914 170.733 188.522 170.73C185.092 170.73 182.312 167.95 182.312 164.521ZM188.522 159.79C187.267 159.79 186.064 160.289 185.177 161.176C184.289 162.063 183.791 163.267 183.791 164.521C183.791 165.776 184.289 166.979 185.177 167.866C186.064 168.754 187.267 169.252 188.522 169.252C189.776 169.252 190.98 168.754 191.867 167.866C192.754 166.979 193.253 165.776 193.253 164.521C193.253 163.267 192.754 162.063 191.867 161.176C190.98 160.289 189.776 159.79 188.522 159.79Z"
            fill="#0D8ECA"
          />
          <path
            d="M220.69 167.696C220.69 165.393 217.235 165.312 217.235 163.976C217.235 163.365 217.718 162.951 218.444 162.951C218.985 162.951 219.653 163.204 220.091 163.515L220.46 162.306C219.988 161.972 219.239 161.707 218.433 161.707C216.889 161.707 215.795 162.697 215.795 164.102C215.795 166.268 219.262 166.418 219.262 167.835C219.262 168.572 218.744 168.963 217.972 168.963C217.062 168.963 216.071 168.503 215.587 168.088L215.518 169.528C216.129 169.908 217.108 170.207 217.914 170.207C219.607 170.207 220.69 169.159 220.69 167.696ZM226.773 167.109C226.773 165.634 226.07 164.437 224.434 164.437C222.741 164.437 221.624 165.738 221.624 167.443C221.624 168.929 222.522 170.207 224.388 170.207C225.195 170.207 225.874 169.965 226.496 169.562L226.531 168.364C226.001 168.756 225.379 169.09 224.538 169.09C223.571 169.09 223.052 168.595 222.972 167.627L226.151 167.535L226.773 167.109ZM222.995 166.809C223.11 166.049 223.605 165.485 224.377 165.485C225.091 165.485 225.425 165.922 225.517 166.729L222.995 166.809ZM229.153 170.15C229.879 170.15 230.501 169.781 230.823 169.24C230.916 169.862 231.353 170.138 231.86 170.138C232.171 170.138 232.413 170.058 232.655 169.965L232.759 169.09C232.609 169.136 232.471 169.171 232.344 169.171C232.102 169.171 232.01 169.044 232.021 168.721L232.079 166.567C232.114 165.243 231.434 164.437 229.96 164.437C229.211 164.437 228.485 164.655 227.898 165.001L228.14 166.095C228.531 165.819 229.142 165.588 229.706 165.588C230.455 165.588 230.766 165.934 230.743 166.648L230.731 166.809C230.582 166.798 230.432 166.786 230.282 166.786C228.428 166.786 227.472 167.512 227.472 168.606C227.472 169.551 228.128 170.15 229.153 170.15ZM229.568 169.205C229.015 169.205 228.773 168.894 228.773 168.468C228.773 167.938 229.176 167.512 230.294 167.512C230.443 167.512 230.57 167.524 230.72 167.535L230.697 168.053C230.662 168.744 230.201 169.205 229.568 169.205ZM236.974 164.437C236.064 164.54 235.465 164.92 235.061 165.669L234.958 164.517C234.624 164.586 233.956 164.678 233.587 164.69C233.656 165.162 233.691 165.715 233.691 166.383V168.042C233.691 168.71 233.679 169.505 233.622 170H235.119C235.084 169.701 235.073 169.217 235.073 168.814V166.994C235.073 166.107 236.017 165.761 236.835 165.888L236.974 164.437ZM242.093 164.955C241.621 164.621 240.976 164.437 240.354 164.437C238.626 164.437 237.417 165.773 237.417 167.466C237.417 168.986 238.569 170.207 240.25 170.207C240.988 170.207 241.437 170.058 242.013 169.712L242.059 168.41C241.518 168.894 241.091 169.067 240.481 169.067C239.594 169.067 238.788 168.457 238.788 167.282C238.788 166.326 239.444 165.577 240.4 165.577C240.896 165.577 241.379 165.738 241.782 166.072L242.093 164.955ZM248.342 170C248.319 169.701 248.296 169.217 248.296 168.814V166.372C248.296 165.162 247.754 164.437 246.614 164.437C245.935 164.437 245.14 164.863 244.691 165.611V163.031C244.691 162.732 244.702 161.949 244.737 161.649C244.391 161.718 243.642 161.787 243.239 161.822C243.285 162.317 243.308 163.031 243.308 163.699V168.099C243.308 168.768 243.285 169.505 243.239 170H244.737C244.702 169.701 244.691 169.274 244.691 168.871V166.89C244.702 166.233 245.382 165.577 246.084 165.577C246.718 165.577 246.914 166.038 246.914 166.706V168.042C246.914 168.71 246.891 169.505 246.833 170H248.342ZM253.794 172.764C253.771 172.419 253.771 171.52 253.771 171.037V163.227C253.771 162.87 253.771 161.822 253.806 161.488C253.506 161.522 252.919 161.557 252.654 161.557C252.711 162.098 252.723 163.411 252.723 164.126V169.988C252.723 170.772 252.711 172.165 252.654 172.764H253.794Z"
            fill="#0D8ECA"
            fillOpacity="0.6"
          />
        </g>
        <line
          x1="336"
          y1="274.5"
          x2="115"
          y2="274.5"
          stroke="#0D8ECA"
          strokeOpacity="0.6"
        >
        </line>
        <line
          x1="336"
          y1="309.5"
          x2="115"
          y2="309.5"
          stroke="#0D8ECA"
          strokeOpacity="0.6"
        />
        <g opacity={1}>
          <circle cx="179.933" cy="308.933" r="5.33333" fill="#585858" />
          <circle cx="224.933" cy="274.933" r="5.33333" fill="#585858" />
          <circle cx="269.933" cy="308.933" r="5.33333" fill="#585858" />
          <circle cx="314.933" cy="274.933" r="5.33333" fill="#585858" />
          <circle cx="134.933" cy="274.933" r="5.33333" fill="#585858" />
          <animate
            attributeName="opacity"
            from={0}
            to={1}
            ref={circlesRef}
            dur="0.3s"
            repeatCount="1"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_2164_74814"
          x="66.7578"
          y="63.1313"
          width="317.502"
          height="495.788"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.7625 0 0 0 0 0.749792 0 0 0 0 0.749792 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_74814"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_74814"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2164_74814"
          x="85.9111"
          y="82.3521"
          width="279.444"
          height="458.567"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.556863 0 0 0 0 0.792157 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_74814"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_74814"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_2164_74814"
          x="68.8994"
          y="63.1313"
          width="317.502"
          height="495.788"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.7625 0 0 0 0 0.749792 0 0 0 0 0.749792 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_74814"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_74814"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_2164_74814"
          x="87.8047"
          y="82.3521"
          width="279.444"
          height="458.567"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.556863 0 0 0 0 0.792157 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_74814"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_74814"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_f_2164_74814"
          x="0.485558"
          y="0.0104599"
          width="452.313"
          height="623.56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="47.7865"
            result="effect1_foregroundBlur_2164_74814"
          />
        </filter>
        <filter
          id="filter5_bd_2164_74814"
          x="107"
          y="90"
          width="237"
          height="443.928"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2164_74814"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.556863 0 0 0 0 0.792157 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_backgroundBlur_2164_74814"
            result="effect2_dropShadow_2164_74814"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_2164_74814"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_2164_74814"
          x="111"
          y="94"
          width="229"
          height="435.928"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.556863 0 0 0 0 0.792157 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_74814"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_74814"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_2164_74814"
          x="161"
          y="140"
          width="128"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.556863 0 0 0 0 0.792157 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_74814"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_74814"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2164_74814"
          x1="129.932"
          y1="426.961"
          x2="210.754"
          y2="543.874"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#055A82" />
          <stop offset="1" stopColor="#7698A8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2164_74814"
          x1="129.932"
          y1="398.027"
          x2="229.863"
          y2="520.464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#68C5EA" />
          <stop offset="1" stopColor="#ABDDF1" />
        </linearGradient>
        <clipPath id="clip0_2164_74814">
          <rect
            width="221"
            height="428"
            fill="white"
            transform="translate(115 98)"
          />
        </clipPath>
        <clipPath id="clip1_2164_74814">
          <path
            d="M115 372H336V517.56C336 522.221 332.221 526 327.56 526H123.44C118.779 526 115 522.221 115 517.56V372Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </>
  )
}
